<KryptonPopinHeader :is-smart-form="isSmartForm" v-on:close="onClose()"></KryptonPopinHeader>